import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header" id="header" style={{
      boxShadow: isScrolled ? '0 4px 20px rgba(0, 0, 0, 0.15)' : '0 2px 10px rgba(0, 0, 0, 0.1)'
    }}>
      <div className="container">
        <div className="header-content">
          <div 
            className="logo" 
            onClick={() => scrollToSection('home')}
            style={{ cursor: 'pointer' }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                scrollToSection('home');
              }
            }}
            aria-label="Go to home"
          >
            {!logoError && (
              <img 
                src={`${process.env.PUBLIC_URL}/logo.png`} 
                alt="JW Salon Logo" 
                className="logo-image"
                onError={() => setLogoError(true)}
              />
            )}
            <h1 className="logo-text">JW Salon</h1>
          </div>
          <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`} id="navMenu">
            <a href="#about" className="nav-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('about');
            }}>About</a>
            <a href="#services" className="nav-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('services');
            }}>Services</a>
            <a href="#contact" className="nav-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('contact');
            }}>Contact</a>
          </nav>
          <button className="book-now-btn" onClick={() => scrollToSection('contact')}>
            Contact Us
          </button>
          <button 
            className="mobile-menu-toggle" 
            id="mobileMenuToggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;



